setTimeout(function () {
  document
    .querySelectorAll(".slider-buttons-custom .prev-next-btn")
    .forEach(function (elem) {
      elem.addEventListener("click", function (event) {
        let event_target;
        debugger;
        if (event.target.tagName == "svg" || event.target.tagName == "path") {
          event_target = event.target.closest("div");
        } else {
          event_target = event.target;
        }
        document
          .querySelectorAll(".flickity-enabled .flickity-prev-next-button")
          .forEach(function (flicky_button) {
            if (
              flicky_button.getAttribute("aria-label") ==
              event_target.dataset.move
            ) {
              debugger;
              flicky_button.click();
            }
          });
      });
    });
}, 5000); // 5000 milliseconds = 5 seconds
